export default __webpack_public_path__ + "static/media/card.c59d9cfa.svg";